/**
 * Copyright (c) 2025-2026 eBUCIS, LLC. All rights reserved.
 *
 * Notification Service - In-app notification API calls
 */

import api from './api'

const notificationService = {
  async list({ limit = 20, offset = 0 } = {}) {
    const res = await api.get('/notifications', { params: { limit, offset } })
    return res.data
  },

  async getUnreadCount() {
    const res = await api.get('/notifications/unread-count')
    return res.data.count
  },

  async markRead(id) {
    const res = await api.patch(`/notifications/${id}/read`)
    return res.data
  },

  async markAllRead() {
    const res = await api.patch('/notifications/read-all')
    return res.data
  }
}

export default notificationService
